module.exports = __webpack_public_path__ + "img/flow_chat-now_hover.d3df1c00.svg";